import gql from 'graphql-tag';
import { FRAGMENT_DYNAMIC_ZONES } from 'src/modules/layout/components/dynamicZone/queries';
import { AssetImageSubtype } from 'src/modules/assets';
import { FRAGMENT_PRODUCT_CARD } from 'src/modules/products';

export const QUERY_PRODUCTS_SERIES = gql`
  query ProductSeries($slug: String!, $withFilters: Boolean! = false) {
    productSeries(where: { slug: $slug }) {
      id
      name_en
      name_de
      description_en
      description_de
      hero_label_en
      hero_label_de
      slug
      image{
        url
        alternativeText
      }
      # assets(where: { subtype: "${AssetImageSubtype.Ambiance}" }, limit: 1) {
      #   ...assetsFields
      # }
      products {
        ...productCardFields
      }
      dynamic_content {
        ...dynamicZone
      }
    }
  }
  ${FRAGMENT_PRODUCT_CARD}
  ${FRAGMENT_DYNAMIC_ZONES}
`;

export const QUERY_PRODUCTS_SERIES_LISTING = gql`
  query ProductSeries {
    productSeries {
      slug
      products {
        id
      }
    }
  }
`;
